// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {guess_browser} from 'zuser_agent';

export const use_browser = (wl?:string[])=>{
    const b = guess_browser();
    const final_br = b.opera ? 'opera' : b.edge ? 'edge' : b.browser
        || 'chrome';
    if (wl)
    {
        if (wl.indexOf(final_br)>-1)
            return final_br;
        return wl[0];
    }
    return final_br;
};
